<template>
  <van-dialog
      v-model="isShow"
      title="提示"
      show-cancel-button
      @confirm="handleConfirm"
      @cancel="handleCancel"
  >
    <div v-if="orderContinuedApplyData != null" style="font-size: 14px;">
      <br>
      <p style="margin-left: 1ch;">店员已提交续单申请,确定后将自动通过该申请</p>
      <br>
      <p style="margin-left: 3ch;">续单申请</p>
      <p v-if="orderContinuedApplyData.message" style="margin-left: 3ch;">
        说明: {{ orderContinuedApplyData.message }}
      </p>
      <p v-else style="margin-left: 3ch;">说明: -</p>
      <div style="display: flex; align-items: center; margin-left: 3ch;">
        截图:
        <span v-if="!orderContinuedApplyData.photoUrls || orderContinuedApplyData.photoUrls.length === 0">-</span>
        <img
            v-for="(item, index) in orderContinuedApplyData.photoUrls"
            :key="index"
            @click="handleclickImg(orderContinuedApplyData.photoUrls, index)"
            :src="item"
            width="40"
            height="40"
            style="border-radius: 5px; margin-left: 2px;"
        />
      </div>
    </div>

    <div v-else style="text-align: center;">
      <p v-if="model.isContinued">确定要将续单转为首单吗?</p>
      <p v-else>确定要将首单转为续单吗?</p>
    </div>
    <br>
  </van-dialog>
</template>

<script>
import {ImagePreview} from "vant";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      required: true,
    },
    orderContinuedApplyData: {
      type: Object,
      default: null,
    },
    orderFOrCChange: {
      type: Function,
      required: true, // 确保传入了这个方法
    },
    // getOrderContinuedApplyList: {
    //   type: Function,
    //   required: true, // 确保传入了这个方法
    // },
  },
  methods: {
    handleConfirm() {
      console.log("=========进入续单弹窗")
      // 调用传递进来的 orderFOrCChange 方法
      this.orderFOrCChange(this.model.id, this.model.isContinued ? 0 : 1);
      // this.getOrderContinuedApplyList(this.model.no);
    },

    handleclickImg(photoUrls, index) {
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    },
    handleCancel() {
      this.$emit('update:isShow', false);  // 关闭弹窗
    },
  },
};
</script>